import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-12 md:py-20 px-4 bg-black text-center relative overflow-hidden" data-id="element-57">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-58">
        <FadeIn className="glow-beige-pulse rounded-3xl p-8 md:p-12 bg-black" data-id="element-59">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-cream mb-8 leading-tight" data-id="element-60">
            No necesitás más teoría. Necesitás mejores herramientas para
            consulta infantil.
          </h2>

          <p className="text-lg md:text-xl text-cream/70 font-medium mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-61">
            Si querés dejar de improvisar, ordenar mejor tu consulta y trabajar
            con materiales que realmente podés usar, imprimir y aplicar, este
            sistema es para vos.
          </p>

          <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBz6mtmyBzD6DgdvkIZ9ms/es-ar?_r=AQABaqLbdvExIDrBl4w56sQObk6WEI9yK3ZFYl3bfdkhYN4&cart_link_id=sLSKiCNr&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-2 bg-terracotta hover:bg-terracottaDark text-white font-bold text-lg md:text-xl py-5 px-10 rounded-xl shadow-xl shadow-terracotta/20 transition-all w-full md:w-auto mb-8" data-id="element-62">
            <span data-id="element-63">🚀</span> ¡SÍ! QUIERO EL MEGAPACK
          </motion.a>

          <div className="flex flex-wrap justify-center gap-6 text-cream/60 text-sm font-bold uppercase tracking-wider" data-id="element-64">
            <span className="flex items-center gap-2" data-id="element-65">
              <Zap size={18} className="text-sand" data-id="element-66" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-67">
              <ShieldCheck size={18} className="text-sand" data-id="element-68" />
              Garantía de 7 días
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}